import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart } from 'lucide-react';

const AppLogo = ({ size = 'sm' }) => {
  const navigate = useNavigate();
  const dims = size === 'sm' ? 'w-9 h-9' : 'w-14 h-14';
  const heartSize = size === 'sm' ? 'w-5 h-5' : 'w-7 h-7';
  const heartIcon = size === 'sm' ? 'w-2.5 h-2.5' : 'w-3.5 h-3.5';
  const inset1 = size === 'sm' ? 'inset-[3px]' : 'inset-[5px]';
  const inset2 = size === 'sm' ? 'inset-[6px]' : 'inset-[10px]';

  return (
    <button
      onClick={() => navigate('/dashboard')}
      className="relative flex items-center justify-center cursor-pointer hover:scale-105 transition-transform"
      style={{ width: size === 'sm' ? 36 : 56, height: size === 'sm' ? 36 : 56 }}
      data-testid="app-logo-home"
      aria-label="Go to dashboard"
    >
      <div className={`absolute inset-0 rounded-full border border-cyan-300/40`} />
      <div className={`absolute ${inset1} rounded-full border border-cyan-400/60`} />
      <div className={`${heartSize} bg-red-500 rounded-full flex items-center justify-center`}>
        <Heart className={`${heartIcon} text-white`} fill="currentColor" />
      </div>
    </button>
  );
};

export default AppLogo;
